/*
 * Gestione del focus per popup e pannelli laterali del tema (WCAG 2.1.2, 2.4.3, 4.1.2).
 *
 * Il tema apre e chiude i popup aggiungendo e togliendo una classe sul <body>, da molti punti diversi.
 * Qui si osserva quella classe, così il comportamento è lo stesso ovunque il popup venga aperto:
 * all'apertura il focus entra nel popup e resta al suo interno, Esc lo chiude,
 * alla chiusura il focus torna all'elemento che lo aveva aperto.
 * Ruolo e nome dei dialog sono nel markup Liquid dei singoli popup.
 */
(function () {
    const POPUPS = {
        'cart-sidebar-show': '#halo-cart-sidebar',
        'auth-sidebar-show': '#halo-auth-sidebar',
        'edit-cart-show': '#halo-edit-cart-popup',
        'ask-an-expert-show': '#halo-ask-an-expert-popup',
        'newsletter-show': '#halo-newsletter-popup',
        'quick-view-show': '#halo-quick-view-popup',
        'quickshop-popup-show': '#halo-quickshop-popup-option-3',
        'term-condition-show': '#halo-term-condition-popup',
        'mobile-popup-active': '.halo-lookbook-popup-mobile'
    };
    const CLOSE = '[data-close-cart-sidebar], [data-close-auth-sidebar], .halo-popup-close, .halo-sidebar-close, [data-close-lookbook-modal]';
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

    const stack = [];
    const body = document.body;

    function isVisible(element) {
        return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    }

    function focusables(popup) {
        return Array.prototype.filter.call(popup.querySelectorAll(FOCUSABLE), isVisible);
    }

    function current() {
        return stack[stack.length - 1];
    }

    function open(className) {
        const popup = document.querySelector(POPUPS[className]);

        if (!popup) return;

        const opener = document.activeElement;

        stack.push({ className: className, popup: popup, opener: opener });

        // Il popup compare con una transizione: il focus si sposta quando è diventato visibile
        let attempts = 0;
        const moveFocus = function () {
            if (current()?.popup !== popup || popup.contains(document.activeElement)) return;

            if (isVisible(popup)) {
                popup.focus({ preventScroll: true });
            } else if (attempts++ < 20) {
                setTimeout(moveFocus, 50);
            }
        };

        setTimeout(moveFocus, 50);
    }

    function close(className) {
        const index = stack.findIndex((entry) => entry.className === className);

        if (index === -1) return;

        const entry = stack.splice(index, 1)[0];
        const focusIsLost = document.activeElement === body || entry.popup.contains(document.activeElement);

        if (focusIsLost && entry.opener && document.contains(entry.opener) && isVisible(entry.opener)) {
            entry.opener.focus({ preventScroll: true });
        }
    }

    let previous = new Set(body.classList);

    new MutationObserver(function () {
        const now = new Set(body.classList);

        Object.keys(POPUPS).forEach(function (className) {
            if (now.has(className) && !previous.has(className)) open(className);
            if (!now.has(className) && previous.has(className)) close(className);
        });

        previous = now;
    }).observe(body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (event) {
        const entry = current();

        if (!entry) return;

        if (event.key === 'Escape') {
            const closeButton = entry.popup.querySelector(CLOSE);

            if (closeButton) {
                event.preventDefault();
                closeButton.click();
            }

            return;
        }

        if (event.key !== 'Tab') return;

        const items = focusables(entry.popup);

        if (items.length === 0) {
            event.preventDefault();
            entry.popup.focus({ preventScroll: true });
            return;
        }

        const first = items[0];
        const last = items[items.length - 1];
        const active = document.activeElement;

        if (!entry.popup.contains(active) || active === entry.popup) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && active === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && active === last) {
            event.preventDefault();
            first.focus();
        }
    });

    // Annunci per gli screen reader (regione aria-live in layout/theme.liquid)
    window.a11yAnnounce = function (message) {
        const region = document.getElementById('a11y-live-region');

        if (!region || !message) return;

        region.textContent = '';
        // In ritardo rispetto allo spostamento del focus nel popup, che altrimenti interrompe l'annuncio
        setTimeout(function () { region.textContent = message; }, 700);
    };
})();
